import {
  ContentState,
  convertFromHTML,
  convertToRaw,
  EditorState,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import styled from 'styled-components';
import { Div, P } from '@vgrubs/components';
import { Box } from '../../styles/styles';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const EditorStyle = styled(Box)`
  padding: 24px;

  :focus {
    border: 1px solid ${({ theme }) => theme.primary};
  }

  .toolbar {
    border: none;
    background: none;
    padding: 0 !important;
    border-bottom: 1px dashed #e3e3e3;
    padding-bottom: 16px !important;
  }

  .editor {
    min-height: 100px;
  }
`;

interface Props {
  onChange: (data: string) => void;
  label?: string;
  value?: string;
}

export const AdminEditor = ({ onChange, label, value, ...props }: Props) => {
  const [editor, setEditor] = useState(EditorState.createEmpty());

  const handleEditorChange = (data: EditorState) => {
    setEditor(data);
    const dataForDatabase = draftToHtml(convertToRaw(data.getCurrentContent()));
    onChange(dataForDatabase);
  };

  useEffect(() => {
    if (value) {
      const { contentBlocks, entityMap } = convertFromHTML(value);
      const content = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      setEditor(EditorState.createWithContent(content));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Div $width="100%">
      {label && (
        <P $mb="10">
          <b>{label}</b>
        </P>
      )}
      <EditorStyle>
        <Editor
          editorState={editor}
          onEditorStateChange={handleEditorChange}
          toolbarClassName="toolbar"
          wrapperClassName="wrapper"
          editorClassName="editor"
          stripPastedStyles={true}
          toolbar={{
            options: [
              'inline',
              'blockType',
              'list',
              'textAlign',
              // 'colorPicker',
              'link',
              'history',
            ],
            blockType: {
              inDropdown: true,
              options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'],
              className: undefined,
              component: undefined,
              dropdownClassName: undefined,
            },
            inline: {
              inDropdown: false,
              className: undefined,
              component: undefined,
              dropdownClassName: undefined,
              options: [
                'bold',
                'italic',
                'underline',
                'strikethrough',
                'superscript',
                'subscript',
              ],
            },
          }}
        />
      </EditorStyle>
    </Div>
  );
};
